import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const ChatFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M19.27 10.19v.8c0 .34-.06.66-.15.97.02.04-.51.85-.51.85s-.65 1.12-1.78 1.44c-.86.24-3.16.24-3.16.24l-3.72.09a.73.73 0 0 0-.29.15l-1.18.7a2.902 2.902 0 0 0 2.9 2.87h4.57c.16 0 .32.06.44.16l3.65 2.17c.09.05.18.07.27.07.28 0 .53-.22.53-.53v-7.42c0-1.12-.64-2.08-1.56-2.56h-.01Z" />
      <Path d="M14.85 3.34H6.88c-1.96 0-3.54 1.58-3.54 3.54v9.03c0 .38.31.64.64.64.11 0 .22-.03.33-.09l4.44-2.64c.15-.13.34-.19.53-.19h5.57a3.54 3.54 0 0 0 3.54-3.54V6.87a3.54 3.54 0 0 0-3.54-3.54v.01Zm-7.6 6.49a1.14 1.14 0 1 1-.001-2.279A1.14 1.14 0 0 1 7.25 9.83Zm3.75 0a1.14 1.14 0 1 1-.001-2.279A1.14 1.14 0 0 1 11 9.83Zm3.78 0a1.14 1.14 0 1 1-.001-2.279 1.14 1.14 0 0 1 .001 2.279Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ChatFilled
